import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7724d879"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "takes" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye-slash mr-2" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye mr-2" }, null, -1))
const _hoisted_5 = { class: "takes__filters" }
const _hoisted_6 = { class: "filters-content" }
const _hoisted_7 = { class: "mt-6 takes__content" }
const _hoisted_8 = { class: "content__block" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block__header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "header__title" }, "Курьеры")
], -1))
const _hoisted_10 = { class: "block__content" }
const _hoisted_11 = { class: "grid grid-cols-3 gap-3 mb-6" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_13 = {
  key: 0,
  class: "flex flex-col items-center justify-center select-none"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-400 mt-1" }, "Загрузка списка курьеров...", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-red-500" }, " При получении списка курьеров произошла ошибка ", -1))
const _hoisted_16 = {
  key: 2,
  class: "text-sm text-gray-400"
}
const _hoisted_17 = { class: "content__map bg-white rounded p-4" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold uppercase" }, "Карта", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-4 text-sm" }, "На карте вы можете увидеть доставки и заборы", -1))
const _hoisted_20 = { class: "mt-4 rounded border border-gray-200 py-3 px-4" }
const _hoisted_21 = { class: "map__marks select-none" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "mark__img w-5 h-6 object-cover",
  src: "/map/green-mark.png"
}, null, -1))
const _hoisted_23 = { class: "ml-1 text-sm font-medium" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "mark__img w-5 h-6 object-cover",
  src: "/map/brown-mark.png"
}, null, -1))
const _hoisted_25 = { class: "ml-1 text-sm font-medium" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "mark__img w-5 h-6 object-cover",
  src: "/map/blue-mark.png"
}, null, -1))
const _hoisted_27 = { class: "ml-1 text-sm font-medium" }
const _hoisted_28 = { class: "map__sectors mt-4" }
const _hoisted_29 = {
  key: 0,
  class: "flex flex-col items-center justify-center select-none"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-400" }, "Загрузка списка секторов...", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-red-500" }, " При получении списка секторов произошла ошибка ", -1))
const _hoisted_32 = {
  key: 2,
  class: "text-sm text-gray-400"
}
const _hoisted_33 = {
  key: 1,
  class: "sectors__list"
}
const _hoisted_34 = ["onClick"]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm" }, "Сектор", -1))
const _hoisted_36 = { class: "mt-4 bg-white rounded" }
const _hoisted_37 = { class: "p-4" }
const _hoisted_38 = { class: "mt-4" }
const _hoisted_39 = { class: "takes__filters-down" }
const _hoisted_40 = { class: "flex items-center gap-3 justify-end mt-3" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search mr-2" }, null, -1))
const _hoisted_43 = { class: "flex items-center justify-end mt-4" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-print mr-2" }, null, -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-cog" }, null, -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download mr-2" }, null, -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-share mr-2" }, null, -1))
const _hoisted_48 = { class: "p-4" }
const _hoisted_49 = {
  class: "max-w-full overflow-hidden overflow-x-auto",
  style: {"padding-bottom":"70px"}
}
const _hoisted_50 = {
  key: 0,
  class: "flex items-center justify-center select-none pb-5"
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-400 mt-1" }, "Загрузка ...", -1))
const _hoisted_52 = {
  key: 2,
  class: "text-sm text-gray-400"
}
const _hoisted_53 = { class: "flex items-center justify-end pb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_wait_list_status_modal = _resolveComponent("wait-list-status-modal")!
  const _component_shortcoming_modal = _resolveComponent("shortcoming-modal")!
  const _component_courier_payment_modal = _resolveComponent("courier-payment-modal")!
  const _component_change_take_date_modal = _resolveComponent("change-take-date-modal")!
  const _component_assign_order_modal = _resolveComponent("assign-order-modal")!
  const _component_take_panel_information = _resolveComponent("take-panel-information")!
  const _component_modal_panel = _resolveComponent("modal-panel")!
  const _component_delivery_panel_information = _resolveComponent("delivery-panel-information")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_new_button = _resolveComponent("new-button")!
  const _component_new_input = _resolveComponent("new-input")!
  const _component_new_checkbox = _resolveComponent("new-checkbox")!
  const _component_new_select = _resolveComponent("new-select")!
  const _component_loader = _resolveComponent("loader")!
  const _component_courier_card = _resolveComponent("courier-card")!
  const _component_new_map = _resolveComponent("new-map")!
  const _component_new_date_picker = _resolveComponent("new-date-picker")!
  const _component_new_limit = _resolveComponent("new-limit")!
  const _component_new_pagination = _resolveComponent("new-pagination")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_takes_table_row = _resolveComponent("takes-table-row")!
  const _component_new_table = _resolveComponent("new-table")!
  const _component_table_scroll_wrapper = _resolveComponent("table-scroll-wrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.wait_list_state.is_opened)
      ? (_openBlock(), _createBlock(_component_wait_list_status_modal, {
          key: 0,
          order: _ctx.wait_list_state.order,
          loading: _ctx.wait_list_state.is_loading,
          onCancel: _ctx.cancelWaitList,
          onSubmit: _ctx.setWaitListStatus
        }, null, 8, ["order", "loading", "onCancel", "onSubmit"]))
      : _createCommentVNode("", true),
    (_ctx.shortcoming_state.is_opened)
      ? (_openBlock(), _createBlock(_component_shortcoming_modal, {
          key: 1,
          order: _ctx.shortcoming_state.order,
          loading: _ctx.shortcoming_state.is_loading,
          onCancel: _ctx.toggleShortcoming,
          onSubmit: _ctx.saveShortcoming
        }, null, 8, ["order", "loading", "onCancel", "onSubmit"]))
      : _createCommentVNode("", true),
    (_ctx.payment_state.is_opened && _ctx.payment_state.order)
      ? (_openBlock(), _createBlock(_component_courier_payment_modal, {
          key: 2,
          "client-id": _ctx.payment_state.order.orderId,
          loading: _ctx.payment_state.is_loading,
          type: _ctx.payment_state.type,
          onCancel: _ctx.togglePayment,
          onSubmit: _ctx.savePaymentTakes
        }, null, 8, ["client-id", "loading", "type", "onCancel", "onSubmit"]))
      : _createCommentVNode("", true),
    (_ctx.change_take_date_state.is_opened)
      ? (_openBlock(), _createBlock(_component_change_take_date_modal, {
          key: 3,
          order: _ctx.change_take_date_state.order,
          loading: _ctx.change_take_date_state.is_loading,
          onCancel: _ctx.cancelChangeDate,
          onSubmit: _ctx.changeDate
        }, null, 8, ["order", "loading", "onCancel", "onSubmit"]))
      : _createCommentVNode("", true),
    (_ctx.assign_order_state.is_opened)
      ? (_openBlock(), _createBlock(_component_assign_order_modal, {
          key: 4,
          order: _ctx.assign_order_state.order,
          loading: _ctx.assign_order_state.is_loading,
          "dispatcher-sector-ids": _ctx.new_dispatcher_store.dispatcherSectorIds,
          onCancel: _ctx.cancelAssignOrder,
          onSubmit: _ctx.assignOrder
        }, null, 8, ["order", "loading", "dispatcher-sector-ids", "onCancel", "onSubmit"]))
      : _createCommentVNode("", true),
    (_ctx.take_panel_state.is_opened && _ctx.take_panel_state.order)
      ? (_openBlock(), _createBlock(_component_modal_panel, {
          key: 5,
          title: _ctx.take_panel_state.order ? _ctx.take_panel_state.order.id : '',
          "takes-status": _ctx.take_panel_state.order.status,
          "is-takes": "",
          "without-footer": "",
          onSubmit: _ctx.closeTakePanel,
          onCancel: _ctx.closeTakePanel
        }, {
          default: _withCtx(() => [
            _createVNode(_component_take_panel_information, {
              "order-id": _ctx.take_panel_state.order.orderId,
              "company-id": _ctx.take_panel_state.order.companyId,
              "has-parking-files": _ctx.take_panel_state.order.hasParkingCourierPayment,
              "has-road-files": _ctx.take_panel_state.order.hasRoadCourierPayment,
              problems: _ctx.take_panel_state.order.problems,
              onAssignOrder: _ctx.startAssignOrder,
              onChangeDate: _ctx.startChangeDate,
              onWaitList: _ctx.startWaitList,
              onShortcoming: _ctx.toggleShortcoming,
              onPayment: _ctx.togglePayment
            }, null, 8, ["order-id", "company-id", "has-parking-files", "has-road-files", "problems", "onAssignOrder", "onChangeDate", "onWaitList", "onShortcoming", "onPayment"])
          ]),
          _: 1
        }, 8, ["title", "takes-status", "onSubmit", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.delivery_panel_state.is_opened)
      ? (_openBlock(), _createBlock(_component_modal_panel, {
          key: 6,
          title: "Информация",
          onSubmit: _ctx.closeDeliveryPanel,
          onCancel: _ctx.closeDeliveryPanel
        }, {
          default: _withCtx(() => [
            _createVNode(_component_delivery_panel_information, {
              order: _ctx.delivery_panel_state.order
            }, null, 8, ["order"])
          ]),
          _: 1
        }, 8, ["onSubmit", "onCancel"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, { title: "Заборы" }),
      (_ctx.state.is_opened)
        ? (_openBlock(), _createBlock(_component_new_button, {
            key: 0,
            class: "NewButton--outline",
            onClick: _ctx.closeMapAndCouriers
          }, {
            default: _withCtx(() => [
              _hoisted_3,
              _createTextVNode(" Скрыть карту и данные курьеров ")
            ]),
            _: 1
          }, 8, ["onClick"]))
        : (_openBlock(), _createBlock(_component_new_button, {
            key: 1,
            class: "NewButton--outline",
            onClick: _ctx.openMapAndCouriers
          }, {
            default: _withCtx(() => [
              _hoisted_4,
              _createTextVNode(" Показать карту и данные курьеров ")
            ]),
            _: 1
          }, 8, ["onClick"]))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_new_input, {
          type: "date",
          placeholder: "Дата забора с",
          value: _ctx.state.dateFrom,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.dateFrom) = $event)),
          disabled: Boolean(_ctx.state.incompletedAllTime)
        }, null, 8, ["value", "disabled"]),
        _createVNode(_component_new_input, {
          type: "date",
          placeholder: "Дата забора по",
          value: _ctx.state.dateTo,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.dateTo) = $event)),
          disabled: Boolean(_ctx.state.incompletedAllTime)
        }, null, 8, ["value", "disabled"]),
        _createVNode(_component_new_checkbox, {
          class: "checkbox--blue",
          value: _ctx.state.incompletedAllTime,
          "onUpdate:value": [
            _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.incompletedAllTime) = $event)),
            _ctx.onIncompletedChange
          ],
          label: "Незавершенные заборы за все время",
          "return-integer": ""
        }, null, 8, ["value", "onUpdate:value"]),
        _createVNode(_component_new_button, {
          onClick: _ctx.loadData,
          class: "NewButton"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Получить данные ")
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_new_select, {
              placeholder: "Секторы",
              disabled: 
                                _ctx.couriers_list_state.is_loading ||
                                _ctx.couriers_list_state.is_failed ||
                                _ctx.sectors_list_state.is_loading ||
                                _ctx.sectors_list_state.is_failed
                            ,
              options: _ctx.sectors_list_state.options,
              loading: _ctx.sectors_list_state.is_loading,
              failed: _ctx.sectors_list_state.is_failed,
              "error-text": "При получении секторов произошла ошибка",
              value: _ctx.couriers_list_state.filters.sectorIds,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.couriers_list_state.filters.sectorIds) = $event)),
              multiselect: "",
              "search-without-refresh": "",
              onRefresh: _cache[4] || (_cache[4] = ($event: any) => (_ctx.loadDeliverySectors(_ctx.new_dispatcher_store.dispatcherSectorIds))),
              onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.loadCouriers(_ctx.new_dispatcher_store.dispatcherSectorIds)))
            }, null, 8, ["disabled", "options", "loading", "failed", "value"]),
            _createVNode(_component_new_input, {
              placeholder: "Поиск по имени",
              disabled: 
                                _ctx.couriers_list_state.is_loading ||
                                _ctx.couriers_list_state.is_failed ||
                                !_ctx.new_dispatcher_store.dispatcherSectorIds.length
                            ,
              value: _ctx.couriers_list_state.query,
              "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.couriers_list_state.query) = $event))
            }, null, 8, ["disabled", "value"]),
            _createVNode(_component_new_button, {
              disabled: 
                                _ctx.couriers_list_state.is_loading ||
                                _ctx.couriers_list_state.is_failed ||
                                !_ctx.new_dispatcher_store.dispatcherSectorIds.length
                            ,
              class: "NewButton--reset",
              onClick: _ctx.resetCouriersFilters
            }, {
              default: _withCtx(() => [
                _hoisted_12,
                _createTextVNode(" Сбросить ")
              ]),
              _: 1
            }, 8, ["disabled", "onClick"])
          ]),
          (
                            _ctx.couriers_list_state.is_loading ||
                            _ctx.couriers_list_state.is_failed ||
                            _ctx.couriersList.length === 0
                        )
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                (_ctx.couriers_list_state.is_loading)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_loader, { class: "primary" }),
                      _hoisted_14
                    ], 64))
                  : (_ctx.couriers_list_state.is_failed)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _hoisted_15,
                        _createVNode(_component_new_button, { class: "NewButton--outline mt-1" }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Обновить ")
                          ]),
                          _: 1
                        })
                      ], 64))
                    : (_ctx.couriersList.length === 0)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_16, "Список курьеров пуст"))
                      : _createCommentVNode("", true)
              ]))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.couriersList, (courier, i) => {
                return (_openBlock(), _createBlock(_component_courier_card, {
                  key: courier.id,
                  courier: courier,
                  class: _normalizeClass({ 'mt-3': i !== 0 })
                }, null, 8, ["courier", "class"]))
              }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _hoisted_19,
        _createVNode(_component_new_map, {
          class: "takes__map mt-4",
          id: "takes-map",
          controls: ['zoomControl'],
          onMapReady: _ctx.onMapReady
        }, null, 8, ["onMapReady"]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", {
              class: _normalizeClass(["flex items-center marks__mark", { 'line-through': !_ctx.untaked_list_state.is_showed }]),
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.toggleUntakedOrders && _ctx.toggleUntakedOrders(...args)))
            }, [
              _hoisted_22,
              _createElementVNode("span", _hoisted_23, "Незабранные заборы (" + _toDisplayString(_ctx.untaked_list_state.orders.length) + ")", 1)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["flex items-center marks__mark", { 'line-through': !_ctx.unassigned_list_state.is_showed }]),
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.toggleUnassignedOrders && _ctx.toggleUnassignedOrders(...args)))
            }, [
              _hoisted_24,
              _createElementVNode("span", _hoisted_25, "Неназначенные заборы (" + _toDisplayString(_ctx.unassigned_list_state.orders.length) + ")", 1)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["flex items-center marks__mark", { 'line-through': !_ctx.undelivered_list_state.is_showed }]),
              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.toggleUndeliveredOrders && _ctx.toggleUndeliveredOrders(...args)))
            }, [
              _hoisted_26,
              _createElementVNode("span", _hoisted_27, "Недоставленные доставки (" + _toDisplayString(_ctx.undelivered_list_state.orders.length) + ")", 1)
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_28, [
            (
                                _ctx.sectors_list_state.is_loading ||
                                _ctx.sectors_list_state.is_failed ||
                                _ctx.sectors_list_state.options.length === 0
                            )
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  (_ctx.sectors_list_state.is_loading)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_loader, { class: "primary" }),
                        _hoisted_30
                      ], 64))
                    : (_ctx.sectors_list_state.is_failed)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _hoisted_31,
                          _createVNode(_component_new_button, {
                            class: "NewButton--outline mt-1",
                            onClick: _cache[10] || (_cache[10] = ($event: any) => (
                                        _ctx.loadDeliverySectors(
                                            _ctx.new_dispatcher_store.dispatcherSectorIds
                                        )
                                    ))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Обновить ")
                            ]),
                            _: 1
                          })
                        ], 64))
                      : (_ctx.sectors_list_state.options.length === 0)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_32, "Список секторов пуст"))
                        : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_33, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sectors_list_state.options, (sector) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: sector.id,
                      class: "list__item flex items-center cursor-pointer",
                      onClick: ($event: any) => (_ctx.setMapCenterOnSector(sector))
                    }, [
                      _hoisted_35,
                      _createElementVNode("span", {
                        class: "text-sm font-bold ml-2",
                        style: _normalizeStyle({ color: sector.color })
                      }, _toDisplayString(sector.name), 5)
                    ], 8, _hoisted_34))
                  }), 128))
                ]))
          ])
        ])
      ])
    ], 512), [
      [_vShow, _ctx.state.is_opened]
    ]),
    _createElementVNode("div", _hoisted_36, [
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("form", {
            onSubmit: _cache[23] || (_cache[23] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_39, [
              _createVNode(_component_new_select, {
                placeholder: "Статус забора",
                label: "title",
                "search-without-refresh": "",
                "search-by": "title",
                options: _ctx.status_types_state.list,
                loading: _ctx.status_types_state.is_loading,
                failed: _ctx.status_types_state.is_failed,
                "error-text": "Произошла ошибка при получении списка типов статусов",
                multiselect: "",
                value: _ctx.takes_list_state.filters.statusIds,
                "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.takes_list_state.filters.statusIds) = $event)),
                onRefresh: _ctx.loadStatusTypes,
                disabled: Boolean(_ctx.state.incompletedAllTime)
              }, null, 8, ["options", "loading", "failed", "value", "onRefresh", "disabled"]),
              _createVNode(_component_new_select, {
                placeholder: "Статус листа ожидания",
                label: "name",
                "search-without-refresh": "",
                options: _ctx.statuses_lo_state.list,
                loading: _ctx.statuses_lo_state.is_loading,
                failed: _ctx.statuses_lo_state.is_failed,
                "error-text": "Произошла ошибка при получении списка статусов",
                multiselect: "",
                value: _ctx.takes_list_state.filters.waitListStatusIds,
                "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.takes_list_state.filters.waitListStatusIds) = $event)),
                onRefresh: _ctx.loadStatusesLO
              }, null, 8, ["options", "loading", "failed", "value", "onRefresh"]),
              _createVNode(_component_new_select, {
                placeholder: "Выберите курьера",
                value: _ctx.takes_list_state.filters.courierId,
                "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.takes_list_state.filters.courierId) = $event)),
                options: _ctx.couriersList,
                loading: _ctx.couriers_list_state.is_loading,
                failed: _ctx.couriers_list_state.is_failed,
                "error-text": "При получении списка курьеров произошла ошибка",
                label: "fullName",
                "search-by": "fullName",
                "search-without-refresh": "",
                "can-deselect": "",
                onRefresh: _ctx.loadCouriers
              }, null, 8, ["value", "options", "loading", "failed", "onRefresh"]),
              _createVNode(_component_new_select, {
                placeholder: "Выберите компанию",
                multiselect: "",
                value: _ctx.takes_list_state.filters.companyIds,
                "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.takes_list_state.filters.companyIds) = $event)),
                options: _ctx.data_state.companies.list,
                loading: _ctx.data_state.companies.is_loading,
                failed: _ctx.data_state.companies.is_failed,
                "error-text": "При получении списка компаний произошла ошибка",
                "search-without-refresh": "",
                "can-deselect": "",
                onRefresh: _ctx.loadCompanies
              }, null, 8, ["value", "options", "loading", "failed", "onRefresh"]),
              _createVNode(_component_new_select, {
                placeholder: "Выберите город",
                value: _ctx.takes_list_state.filters.cityId,
                "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.takes_list_state.filters.cityId) = $event)),
                options: _ctx.data_state.cities.list,
                loading: _ctx.data_state.cities.is_loading,
                failed: _ctx.data_state.cities.is_failed,
                "error-text": "При получении списка городов произошла ошибка",
                "search-without-refresh": "",
                "can-deselect": "",
                onRefresh: _ctx.loadCities
              }, null, 8, ["value", "options", "loading", "failed", "onRefresh"]),
              _createVNode(_component_new_select, {
                placeholder: "Выберите период",
                value: _ctx.takes_list_state.filters.periodId,
                "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.takes_list_state.filters.periodId) = $event)),
                options: _ctx.data_state.periods.list,
                loading: _ctx.data_state.periods.is_loading,
                failed: _ctx.data_state.periods.is_failed,
                "error-text": "При получении списка периодов произошла ошибка",
                searchable: false,
                "search-without-refresh": "",
                "can-deselect": "",
                label: "title",
                onRefresh: _ctx.loadPeriods
              }, null, 8, ["value", "options", "loading", "failed", "onRefresh"]),
              _createVNode(_component_new_input, {
                value: _ctx.takes_list_state.filters.address,
                "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.takes_list_state.filters.address) = $event)),
                placeholder: "Поиск по адресу"
              }, null, 8, ["value"]),
              _createVNode(_component_new_input, {
                value: _ctx.takes_list_state.filters.orderNumber,
                "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.takes_list_state.filters.orderNumber) = $event)),
                placeholder: "Поиск по номеру заказа"
              }, null, 8, ["value"]),
              _createVNode(_component_new_select, {
                placeholder: "Нужна коробка",
                options: _ctx.LO_STATUSES,
                "select-by": "key",
                value: _ctx.takes_list_state.filters.hasPackType,
                "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.takes_list_state.filters.hasPackType) = $event))
              }, null, 8, ["options", "value"]),
              _createVNode(_component_new_select, {
                value: _ctx.takes_list_state.filters.waitListComment,
                "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.takes_list_state.filters.waitListComment) = $event)),
                placeholder: "Комментарий",
                options: _ctx.comments_state.list,
                loading: _ctx.comments_state.is_loading,
                failed: _ctx.comments_state.is_failed,
                "error-text": "При получении списка произошла ошибка",
                "select-by": "text",
                "search-by": "text",
                label: "text",
                onRefresh: _ctx.loadComments,
                onChange: _ctx.onCommentChange
              }, null, 8, ["value", "options", "loading", "failed", "onRefresh", "onChange"]),
              _createVNode(_component_new_date_picker, {
                placeholder: "Дата создания от",
                format: "iso",
                value: _ctx.takes_list_state.filters.createdAtFrom,
                "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.takes_list_state.filters.createdAtFrom) = $event))
              }, null, 8, ["value"]),
              _createVNode(_component_new_date_picker, {
                placeholder: "Дата создания по",
                format: "iso",
                value: _ctx.takes_list_state.filters.createdAtTo,
                "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.takes_list_state.filters.createdAtTo) = $event))
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_40, [
              _createVNode(_component_new_button, {
                type: "button",
                class: "NewButton--reset mr-2",
                disabled: 
                                    _ctx.takes_list_state.is_loading || _ctx.takes_list_state.is_failed
                                ,
                onClick: _ctx.resetTakeOrdersFilters
              }, {
                default: _withCtx(() => [
                  _hoisted_41,
                  _createTextVNode(" Сбросить ")
                ]),
                _: 1
              }, 8, ["disabled", "onClick"]),
              _createVNode(_component_new_button, {
                type: "submit",
                class: "NewButton--search"
              }, {
                default: _withCtx(() => [
                  _hoisted_42,
                  _createTextVNode(" Поиск ")
                ]),
                _: 1
              })
            ])
          ], 32),
          _createElementVNode("div", _hoisted_43, [
            _createVNode(_component_new_button, {
              loading: _ctx.mass_print_state.is_loading,
              disabled: _ctx.mass_print_state.is_loading,
              class: "NewButton--search mr-3",
              onClick: _ctx.downloadMassPdf
            }, {
              default: _withCtx(() => [
                _hoisted_44,
                _createTextVNode(" Массовая печать ")
              ]),
              _: 1
            }, 8, ["loading", "disabled", "onClick"]),
            _createVNode(_component_new_button, {
              class: "NewButton--search mr-3",
              loading: _ctx.takes_list_state.is_loading,
              disabled: !_ctx.takes_list_state.orders.length,
              onClick: _ctx.tablesStore.toggleModal
            }, {
              default: _withCtx(() => [
                _hoisted_45
              ]),
              _: 1
            }, 8, ["loading", "disabled", "onClick"]),
            _createVNode(_component_new_button, {
              loading: _ctx.report_state.is_loading,
              disabled: _ctx.report_state.is_loading,
              class: "NewButton--search mr-3",
              onClick: _ctx.downloadReport
            }, {
              default: _withCtx(() => [
                _hoisted_46,
                _createTextVNode(" Выгрузить отчет ")
              ]),
              _: 1
            }, 8, ["loading", "disabled", "onClick"]),
            (_ctx.assign_order_state.selected_orders.length)
              ? (_openBlock(), _createBlock(_component_new_button, {
                  key: 0,
                  class: "NewButton--search",
                  onClick: _ctx.toggleSubmitCheckedOrders
                }, {
                  default: _withCtx(() => [
                    _hoisted_47,
                    _createTextVNode(" Выдать выбранные ")
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            _createVNode(_component_new_limit, {
              disabled: 
                                _ctx.takes_list_state.is_loading ||
                                _ctx.takes_list_state.is_failed ||
                                !_ctx.new_dispatcher_store.dispatcherSectorIds
                            ,
              value: _ctx.takes_list_state.filters.limit,
              "total-items": _ctx.takes_list_state.filters.total_items,
              onChange: _ctx.onLimitChange
            }, null, 8, ["disabled", "value", "total-items", "onChange"]),
            _createVNode(_component_new_pagination, {
              class: "ml-6",
              disabled: _ctx.takes_list_state.is_loading || _ctx.takes_list_state.is_failed,
              "current-page": _ctx.takes_list_state.filters.current_page,
              "total-pages": _ctx.takes_list_state.filters.total_pages,
              onChangePage: _ctx.onChangePage
            }, null, 8, ["disabled", "current-page", "total-pages", "onChangePage"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_48, [
        _createElementVNode("div", _hoisted_49, [
          _createVNode(_component_table_scroll_wrapper, {
            loading: _ctx.takes_list_state.is_loading
          }, {
            default: _withCtx(() => [
              (
                                _ctx.takes_list_state.is_loading ||
                                _ctx.takes_list_state.is_failed ||
                                _ctx.takes_list_state.orders.length === 0
                            )
                ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                    (_ctx.takes_list_state.is_loading)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(_component_loader, { class: "primary mr-2" }),
                          _hoisted_51
                        ], 64))
                      : (_ctx.takes_list_state.is_failed)
                        ? (_openBlock(), _createBlock(_component_failed_fetch, {
                            key: 1,
                            loading: _ctx.takes_list_state.is_loading,
                            text: "При получении списка заборов произошла ошибка",
                            onRefresh: _ctx.loadTakeOrders
                          }, null, 8, ["loading", "onRefresh"]))
                        : (_ctx.takes_list_state.orders.length === 0)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_52, "Список пуст"))
                          : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createBlock(_component_new_table, {
                    key: 1,
                    class: "mt-3",
                    columns: _ctx.TAKES_COLUMNS,
                    rows: _ctx.takes_list_state.orders,
                    "selected-rows": _ctx.assign_order_state.selected_orders,
                    "has-checkbox-column": "",
                    "has-index-column": "",
                    "clickable-rows": "",
                    onSelectRow: _ctx.onSelectTake,
                    onUnselectRow: _ctx.onUnselectTake,
                    onSelectAll: _ctx.selectAllTakes,
                    onUnselectAll: _ctx.unselectAllTakes,
                    onRowClick: _ctx.openTakePanel
                  }, {
                    checkbox: _withCtx(() => []),
                    "table-index": _withCtx(() => []),
                    td: _withCtx(({ column, row }) => [
                      _createVNode(_component_takes_table_row, {
                        column: column,
                        row: row,
                        "is-can-assign": _ctx.isCanAssign,
                        "is-can-change-date": _ctx.isCanChangeDate,
                        "is-can-set-wait-list": true,
                        onAssignOrder: _ctx.startAssignOrder,
                        onChangeDate: _ctx.startChangeDate,
                        onWaitList: _ctx.startWaitList,
                        onShortcoming: _ctx.toggleShortcoming,
                        onPayment: _ctx.togglePayment,
                        onResend: _ctx.resendOrder
                      }, null, 8, ["column", "row", "is-can-assign", "is-can-change-date", "onAssignOrder", "onChangeDate", "onWaitList", "onShortcoming", "onPayment", "onResend"])
                    ]),
                    _: 1
                  }, 8, ["columns", "rows", "selected-rows", "onSelectRow", "onUnselectRow", "onSelectAll", "onUnselectAll", "onRowClick"]))
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      _createElementVNode("div", _hoisted_53, [
        _createVNode(_component_new_limit, {
          disabled: 
                        _ctx.takes_list_state.is_loading ||
                        _ctx.takes_list_state.is_failed ||
                        !_ctx.new_dispatcher_store.dispatcherSectorIds.length
                    ,
          value: _ctx.takes_list_state.filters.limit,
          "total-items": _ctx.takes_list_state.filters.total_items,
          onChange: _ctx.onLimitChange
        }, null, 8, ["disabled", "value", "total-items", "onChange"]),
        _createVNode(_component_new_pagination, {
          class: "ml-6",
          disabled: _ctx.takes_list_state.is_loading || _ctx.takes_list_state.is_failed,
          "current-page": _ctx.takes_list_state.filters.current_page,
          "total-pages": _ctx.takes_list_state.filters.total_pages,
          onChangePage: _ctx.onChangePage
        }, null, 8, ["disabled", "current-page", "total-pages", "onChangePage"])
      ])
    ])
  ]))
}